export const base_table = { page: 1, per_page: 20, order_by: "name", order_dir: "asc" };

export const base_object = {
	id: "",
	slug: "",
	name: "",
	estates: [],
	hectares: "",
	time_open: "",
	time_close: "",
	notification_range: "",
	day_selection: false,
	days: [],
	region: null,
	locality: null,
};
